import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {SSOSteps} from "@/pages/sso/SSOSteps.tsx";
import {AccessDeniedPage} from "@/pages/website/AccessDeniedPage.tsx";

export const SSOPage = () => {
  const {user} = useCurrentUserContext();
  if (!user?.has_admin_access) {
    return <AccessDeniedPage />;
  }

  return (
    <ContentContainer title="Single Sign-on: Use SAML">
      <Helmet>
        <title>Single Sign-on: Use SAML</title>
      </Helmet>
      <Suspense>
        <UpErrorBoundary>
          <SSOSteps />
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
